export default __webpack_public_path__ + "static/media/loose-weight.361af6c8.png";